import React from "react";

interface PointsFidleliteMethodProps {
  total: number;
  pointsFideliteEquivalent: number; // fideliteAmount in the parent (TND used)
  setpointsFideliteEquivalent: (amount: number) => void;
  onAmountChange: (amount: number) => void; // handleEnteredAmountFidelite in the parent
  givenAmout?: number;
  currentClient?: {
    points?: number;
    equivalentMoney?: number;
  };
}

const PointsFidleliteMethod = ({
  total,
  pointsFideliteEquivalent,
  setpointsFideliteEquivalent,
  onAmountChange,
  currentClient,
}: PointsFidleliteMethodProps) => {
  const availableMoney = Number(currentClient?.equivalentMoney) || 0;
  const availablePoints = Number(currentClient?.points) || 0;

  // ratio: how many points correspond to 1 TND (ex: 250 pts / 250 TND = 1)
  const pointsPerTND = availableMoney > 0 ? availablePoints / availableMoney : 0;

  // The cashier can never use more than what the client has,
  // nor more than the total to pay
  const maxUsable = Math.min(availableMoney, Number(total) || availableMoney);

  const usedAmount = Number(pointsFideliteEquivalent) || 0;
  const usedPoints = Math.round(usedAmount * pointsPerTND);

  // Live preview of what will remain after payment
  const remainingMoney = Math.max(0, availableMoney - usedAmount);
  const remainingPoints = Math.max(0, availablePoints - usedPoints);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;

    // allow clearing the field while typing
    if (raw === "") {
      onAmountChange(0);
      return;
    }

    let value = parseFloat(raw);
    if (isNaN(value) || value < 0) value = 0;

    // clamp to what the client can actually spend
    if (value > maxUsable) value = maxUsable;

    // onAmountChange = handleEnteredAmountFidelite:
    // it sets fideliteAmount, recalculates spentPoints and the global total
    onAmountChange(value);
  };

  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form
            className="form-inline search-full form-inline search"
            role="search"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="search-bar" style={{ marginBottom: "7px" }}>
              <input
                type="number"
                className="form-control search-form-control ml-lg-auto"
                placeholder="Montant fidélité (TND)"
                value={usedAmount === 0 ? "" : usedAmount}
                min={0}
                max={maxUsable}
                step="0.001"
                onChange={handleChange}
              />
              {usedAmount ? (
                <button
                  type="button"
                  onClick={() => onAmountChange(0)}
                  style={{
                    position: "absolute",
                    right: "10%",
                    border: "none",
                    background: "transparent",
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
              ) : null}
            </div>
          </form>
        </div>
      </div>

      {/* Summary: available / used / remaining */}
      <div
        style={{
          padding: "8px 12px",
          fontSize: "13px",
          lineHeight: "1.8",
        }}
      >
        <div>
          Disponible : <strong>{availableMoney.toFixed(3)} TND</strong> (
          {availablePoints} pts)
        </div>
        <div>
          Utilisé : <strong>{usedAmount.toFixed(3)} TND</strong> ({usedPoints}{" "}
          pts)
        </div>
        <div style={{ color: "#009688" }}>
          Reste après paiement :{" "}
          <strong>{remainingMoney.toFixed(3)} TND</strong> ({remainingPoints}{" "}
          pts)
        </div>
      </div>
    </div>
  );
};

export default PointsFidleliteMethod;